import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {Dots} from "../dots/components/dots";
import {GameCompetitorViewModel} from "../../../domain/partial-game/models/game-competitor/game-competitor-view-model";
import styles from "./game-score.module.scss";
import classNames from "classnames";

export class GameCenterHeaderBonusIndicationProps extends BaseProps {
  foulsBonusText: String;
  isSmallView: Boolean;
  competitor: GameCompetitorViewModel;
}

export const GameFouls = observer(({
                            competitor,
                            foulsBonusText,
                            isSmallView,
                            isHomeCompetitor
                          }: GameCenterHeaderBonusIndicationProps) => {
  const {fouls} = competitor;

  if (!fouls) {
    return null;
  }

  const gameFoulsDotProps = {
    competitor,
    isSmallView
  }

  return (
    <div className={classNames(styles.game_fouls_container, {[styles.away_competitor]: !isHomeCompetitor})}>
      <Dots {...gameFoulsDotProps}/>
      <div className={classNames(styles.game_fouls_bonus)}>{fouls?.hasBonus ? foulsBonusText : ''}</div>
    </div>
  )
});
